<h2 mat-dialog-title>Error</h2>
<mat-dialog-content>{{ data.errorMessage }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="closeDialog()">OK</button>
</mat-dialog-actions>
